import VueRouter from "vue-router";
import { api } from "./api";

export const handleLoginCheck = async (router: VueRouter): Promise<void> => {
    const whoIndeed = await api.whoAmI();
    const excludedRoutes = ["login"];
    if (!whoIndeed) {
        if (!excludedRoutes.includes(router.currentRoute.name!)) {
            router.push({name: "login"});
        }
    }
}